import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import type { TypographyVariant } from '@sorare/core/src/atoms/typography';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { transferMarket } from '@sorare/core/src/lib/glossary';

import { ItemEligibility } from '@sorare/marketplace/src/components/card/ItemEligibility';

import type { BundledAuctionTitle_card } from './__generated__/index.graphql';

interface Props {
  team: string | null;
  cards: BundledAuctionTitle_card[];
  Variant: TypographyVariant;
}

const Root = styled.div`
  display: flex;
  gap: 10px;
`;

export const BundledAuctionTitle = ({ team, cards, Variant }: Props) => {
  const [{ sportSeason }] = cards;

  return (
    <Root>
      <div>
        {!!team && (
          <Variant>
            <FormattedMessage {...transferMarket.bundle} />
            {!!team && (
              <>
                {' • '}
                {team}
              </>
            )}
          </Variant>
        )}
        <BodyM>{sportSeason.name}</BodyM>
      </div>
      <ItemEligibility cards={cards} />
    </Root>
  );
};

BundledAuctionTitle.fragments = {
  card: gql`
    fragment BundledAuctionTitle_card on Card {
      slug
      sportSeason {
        name
      }
      ...ItemEligibility_card
    }
    ${ItemEligibility.fragments.card}
  ` as TypedDocumentNode<BundledAuctionTitle_card>,
};
